// /confirm/:token — página pública de confirmação por link (M13). M0: placeholder sem autenticação.
import { Alert, AlertDescription, AlertTitle } from '@giyus/ui';
import { useTranslation } from 'react-i18next';

import { APP_VERSION } from '../lib/env';
import { LanguageSwitcher } from '../shell/LanguageSwitcher';

export function ConfirmPage() {
  const { t } = useTranslation(['shell', 'common']);
  return (
    <div className="flex min-h-svh flex-col bg-background text-foreground" data-testid="confirm">
      <header className="border-b bg-card">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
          <span className="text-title font-semibold tracking-tight">{t('common:app.name')}</span>
          <LanguageSwitcher />
        </div>
      </header>
      <main id="main" className="mx-auto w-full max-w-3xl flex-1 px-4 py-8">
        <h1 className="mb-4 text-headline font-semibold tracking-tight">
          {t('shell:confirm.title')}
        </h1>
        <Alert>
          <AlertTitle>
            {t('shell:home.milestone', { milestone: 'M13', status: t('shell:confirm.title') })}
          </AlertTitle>
          <AlertDescription>
            <p>{t('shell:confirm.message')}</p>
          </AlertDescription>
        </Alert>
      </main>
      <footer className="border-t">
        <div className="mx-auto max-w-3xl px-4 py-3 text-caption text-muted-foreground">
          {t('shell:footer.version', { version: APP_VERSION })}
        </div>
      </footer>
    </div>
  );
}
